const STATUS_BY_SERVICE: Record<string, string> = {
  ADD_DOT_NUMBER: 'Looking up your DOT number with the FMCSA…',
  CONFIRM_DOT_NUMBER: 'Pulling your company details…',
  UPLOAD_DOCUMENTS: 'Reading your documents…',
  EARLY_LOSS_RUN_UPLOAD: 'Reading your loss runs…',
  EARLY_BOR_AUTHORIZATION: 'Preparing to fill your insurance applications…',
}

// Shown for at least this long, even when the answer comes back sooner.
const HOLD_MS_BY_SERVICE: Record<string, number> = {
  EARLY_BOR_AUTHORIZATION: 4000,
}

/** The status line for the step just answered; most steps have none. */
export function chatStatusFor(service: string | undefined): string | undefined {
  return service ? STATUS_BY_SERVICE[service] : undefined
}

/** How long the step's status line stays up after the answer is sent; 0 when it isn't held. */
export function chatStatusHoldMs(service: string | undefined): number {
  return service ? (HOLD_MS_BY_SERVICE[service] ?? 0) : 0
}
